import axios from "axios";

let customerSvc = process.env.VUE_APP_COMPANY_API_URL;
let companyRoot = process.env.VUE_APP_COMPANY_USER_ROOT;

axios.defaults.headers.common["api_key"] =
	process.env.VUE_APP_CARD_USER_API_KEY;

const customerAxiosInstance = axios.create({
	baseURL: customerSvc,
});

export default {
	customerService: {
		searchCampaigns(searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/plus/comercial/campaigns" +
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		addCampaign(formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/plus/comercial/campaigns",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updateCampaign(campaign, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/plus/comercial/campaigns/" + campaign.id,
				campaign,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		getCampaign(campaignId, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/plus/comercial/campaigns/" +
				campaignId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		publishCampaign(campaign, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/plus/comercial/campaigns/" + campaign.id + "/publish",
				campaign,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		deleteCampaign(campaign_id, token) {
			return customerAxiosInstance.delete(
				companyRoot +  "/v1/plus/comercial/campaigns/" + campaign_id,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		getPartners( token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/plus/comercial/campaigns/partners"
				,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		getPartnerDetails(gameId, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/plus/comercial/campaigns/partners/" +
				gameId,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		addPartner(formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/plus/comercial/campaigns/partners",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		updatePartner(game, token) {
			return customerAxiosInstance.put(
				companyRoot + "/v1/plus/comercial/campaigns/partners/" + game.mission_id,
				game,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		validateImage( formData, token) {
			return customerAxiosInstance.post(
				companyRoot + "/v1/plus/campaigns/resources",
				formData,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		// categories
		getLocations(searchParams, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/plus/comercial/campaigns/locations" +
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		// workpoints	
		getWorkpoints(searchParams, token) {
			return customerAxiosInstance.post(
				companyRoot +
				"/v1/plus/comercial/campaigns/partners/workpoints",
				searchParams,
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},

		// dashboard 
		getVouchersForPartner(partnerId, token) {
			return customerAxiosInstance.get(
				companyRoot +
				"/v1/plus/comercial/partners/" + partnerId + "/vouchers",
				{
					headers: {
						Authorization: "Bearer " + btoa(token),
						"Content-Type": "application/json",
					},
				}
			);
		},
		
	},
};
